import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TranProductList = ({ productList, totalPrice }) => {

    return (
        <Box>
            {productList && productList.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Typography variant="subtitle2" component="div">이력 제품이 없습니다.</Typography>
                </Box>
            ) : (
                <Box>
                    <Box sx={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2,
                        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,

                    }}>
                        <Box><Typography variant="subtitle2" component="div">총 {productList?.length}건</Typography></Box>
                        <Box><Typography variant="subtitle2" component="div">총합 : ₩ {totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography></Box>
                    </Box>
                    <TableContainer component={Box}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>No</TableCell>
                                    <TableCell>제조사</TableCell>
                                    <TableCell>매입처</TableCell>
                                    <TableCell>제품명</TableCell>
                                    <TableCell>모델명</TableCell>
                                    <TableCell>수량</TableCell>
                                    <TableCell>단가</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {productList && productList.map((product, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{product?.masPartnerNm}</TableCell>
                                        <TableCell>{product?.pricePartnerNm}</TableCell>
                                        <TableCell>{product?.productNm}</TableCell>
                                        <TableCell>{product?.modelNm}</TableCell>
                                        <TableCell sx={{ width: '80px' }}>
                                            {product?.productCnt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                        <TableCell sx={{ width: '120px' }}>
                                            ₩ {product?.priceVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box >
            )}



        </Box >
    )
}

export default TranProductList